import React, { Component } from 'react'
import { Button, DatePicker, Form, Input, Modal, Spin } from 'antd'
import moment from 'moment'
import _ from 'lodash'

import './PreviewPanel.scss'

const FormItem = Form.Item

export default class PreviewPanel extends Component {
    constructor(props) {
        super(props)

        this.state = {
            modalVisible: false,
            customAlertContent: undefined,
            customAlertDue: undefined
        }

        this.showModal = this.showModal.bind(this)
        this.closeModal = this.closeModal.bind(this)
        this.handleConfirm = this.handleConfirm.bind(this)
        this.handleCustomAlertContentChange = this.handleCustomAlertContentChange.bind(this)
        this.handleCustomAlertDueChange = this.handleCustomAlertDueChange.bind(this)
    }

    showModal() {
        this.setState({ modalVisible: true })
    }

    closeModal() {
        this.setState({ modalVisible: false })
    }

    handleConfirm() {
        const { onProjectCustomAlertConfirm, onDocumentCustomAlertConfirm, previewInfo } = this.props
        const { customAlertContent, customAlertDue } = this.state

        if (previewInfo.type === 'project')
            onProjectCustomAlertConfirm(customAlertContent, customAlertDue)
        else if (previewInfo.type === 'document')
            onDocumentCustomAlertConfirm(customAlertContent)

        this.setState({ modalVisible: false })
    }

    handleCustomAlertContentChange(e) {
        this.setState({ customAlertContent: e.target.value })
    }

    handleCustomAlertDueChange(date, dateString) {
        this.setState({ customAlertDue: date })
    }

    componentDidUpdate(prevProps, prevState) {
        const { previewInfo } = this.props

        if (!_.isEqual(prevProps.previewInfo.customAlert, previewInfo.customAlert)) {
            if (previewInfo.type === 'project') {
                this.setState({
                    customAlertContent: previewInfo.customAlert.content,
                    customAlertDue: previewInfo.customAlert.due ? moment(previewInfo.customAlert.due) : null
                })
            } else if (previewInfo.type === 'document') {
                console.log(previewInfo.customAlert)
                this.setState({
                    customAlertContent: previewInfo.customAlert,
                    customAlertDue: null
                })
            }

        }
    }

    renderPreview() {
        const { previewInfo } = this.props

        if (_.isEmpty(previewInfo.previewList)) {
            return (
                <div className="preview-list-loading">
                    <Spin />
                </div>
            )
        } else {
            return _.map(previewInfo.previewList, (previewItem, idx) => (
                <div className="preview-list" key={`preview-${idx}`}>
                    <span className="preview-label">{previewItem.label} : </span>{previewItem.value}
                </div>
            ))
        }
    }

    renderAlert() {
        const { previewInfo } = this.props
        let customAlert = ''
        if (previewInfo.type === 'project' && !_.isEmpty(previewInfo.customAlert.content)) {
            customAlert = `${previewInfo.customAlert.content}`
            if (previewInfo.customAlert.due)
                customAlert += ` (Due: ${moment(previewInfo.customAlert.due).format('YYYY-MM-DD')})`
        } else if (previewInfo.type === 'document' && !_.isEmpty(previewInfo.customAlert)) {
            customAlert = previewInfo.customAlert
        }

        return (
            <div className="alert-list">
                <p>What should we do:</p>
                <ol>
                    {
                        _.map(previewInfo.alertList, (alertItem, idx) => {
                            return <li key={`alert-${idx}`}>{alertItem}</li>
                        })
                    }
                    <li 
                        className="custom-alert" 
                        onClick={this.showModal}
                    >
                        {customAlert || 'Click to edit the custom alert'}
                    </li>
                </ol>
            </div>
        )
    }

    renderModalContent(type) {
        const { customAlertContent, customAlertDue } = this.state

        if (type === 'project')
            return (
                <div className="content">
                    <Form>
                        <FormItem
                            label="Alert Content"
                            labelCol={{ span: 8 }}
                            wrapperCol={{ span: 14 }}
                        >
                            <Input 
                                type="textarea" 
                                autosize
                                value={customAlertContent}
                                onChange={this.handleCustomAlertContentChange}
                            />
                        </FormItem>
                        <FormItem
                            label="Due Date"
                            labelCol={{ span: 8 }}
                            wrapperCol={{ span: 16 }}
                        >
                            <DatePicker 
                                placeholder="Select Date" 
                                value={customAlertDue}
                                onChange={this.handleCustomAlertDueChange}
                            />
                        </FormItem>
                    </Form>
                </div>
            )
        else
            return (
                <div className="content">
                    <Form>
                        <FormItem
                            label="Alert Content"
                            labelCol={{ span: 8 }}
                            wrapperCol={{ span: 14 }}
                        >
                            <Input 
                                type="textarea" 
                                autosize
                                value={customAlertContent}
                                onChange={this.handleCustomAlertContentChange}
                            />
                        </FormItem>
                    </Form>
                </div>
            )
    }

    renderPanel() {
        const { previewInfo } = this.props
        const { modalVisible } = this.state

        return (
            <div className="PreviewPanel">
                {this.renderPreview()}
                {this.renderAlert()}
                <Modal
                    width="60%"
                    wrapClassName="custom-alert-modal"
                    visible={modalVisible}
                    footer={null}
                    onCancel={this.closeModal}
                >
                    <p className="info">{previewInfo.type === 'project' ? 'Alert system will notify you 3 days before the due date.' : 'You can modify the description of this document.'}</p>
                    {this.renderModalContent(previewInfo.type)}
                    <div className="footer">
                        <Button type="primary" size="large" onClick={this.handleConfirm}>Save</Button>
                    </div>
                </Modal>
            </div>
        )
    }

    render() {
        const { selectedProject } = this.props

        if (!_.isEmpty(selectedProject)) {
            return this.renderPanel()
        } else {
            return (
                <div className="PreviewPanel">
                    <div className="empty-alert">
                        Select a project to view the information
                    </div>
                </div>
            )
        }
    }
}



// WEBPACK FOOTER //
// ./src/Commons/PreviewPanel/PreviewPanel.js